export const identity = input => input



// WEBPACK FOOTER //
// ./src/utils/boolean/identity.js